import { ms_applicant_alevel } from "@v2/validators";
import { Form, Formik } from "formik";
import React from "react";
import ErrorMessage from "../../components/ErrorMessage";
import { axiospost } from "../../helpers/httprequest";
import { useQueryClient } from "@tanstack/react-query";
import swal from "../../helpers/swal";

const Ijmb = ({ data, setdata }) => {
  const queryClient = useQueryClient(); // Access the Query Client

  const _save = async (values) => {
    try {
      const req = await axiospost("ms_applicant_alevel", {
        type: "IJMB",
        results: values,
      });
      if (req.status !== 200) {
        throw new Error("Sorry, system could not finish processing your request");
      }
      const { data: result } = req;
      if (result && result.type === "success") {
        const { message, type } = result;
        swal(type, message);
        queryClient.invalidateQueries({ queryKey: ["aLevelResult"] });
      } else {
        throw new Error(result.message);
      }
    } catch ({ message }) {
      swal("warning", message);
    }
  };
  return (
    <Formik
      initialValues={{
        institutionName: data ? data?.institutionName : "",
        yearOfGraduation: data ? data?.yearOfGraduation : "",
        educationSubject: data ? data?.educationSubject : "",
        educationSubjectGrade: data ? data?.educationSubjectGrade : "",
        educationSubject2: data ? data?.educationSubject2 : "",
        educationSubject2Grade: data ? data?.educationSubject2Grade : "",
        educationSubject3: data ? data?.educationSubject3 : "",
        educationSubject3Grade: data ? data?.educationSubject3Grade : "",
      }}
      validationSchema={ms_applicant_alevel.IJMB}
      initialTouched={{ zip: true }}
      onSubmit={_save}
    >
      {({ isSubmitting, touched, errors }) => (
        <Form className="row">
          <div className="col-md-7">
            <ErrorMessage
              name={"institutionName"}
              label="Institution Name"
              type="text"
              key={`error_institutionName`}
              errors={errors?.institutionName}
              touched={touched?.institutionName}
            />
          </div>
          <div className="col-md-5">
            <ErrorMessage
              name={"yearOfGraduation"}
              label="Year of Graduation"
              type="text"
              key={`error_yearOfGraduation`}
              errors={errors?.yearOfGraduation}
              touched={touched?.yearOfGraduation}
            />
          </div>

          <div className="col-md-7">
            <ErrorMessage
              name={"educationSubject"}
              label="Education Subject"
              type="text"
              key={`error_educationSubject`}
              errors={errors?.educationSubject}
              touched={touched?.educationSubject}
            />
          </div>
          <div className="col-md-5">
            <ErrorMessage
              name={"educationSubjectGrade"}
              label="Education Subject Grade (A, B, C, D, ...)"
              type="text"
              key={`error_educationSubjectGrade`}
              errors={errors?.educationSubjectGrade}
              touched={touched?.educationSubjectGrade}
            />
          </div>

          <div className="col-md-7">
            <ErrorMessage
              name={"educationSubject2"}
              label="Education Subject 2"
              type="text"
              key={`error_educationSubject2`}
              errors={errors?.educationSubject2}
              touched={touched?.educationSubject2}
            />
          </div>
          <div className="col-md-5">
            <ErrorMessage
              name={"educationSubject2Grade"}
              label="Education Subject 2 Grade (A, B, C, D, ...)"
              type="text"
              key={`error_educationSubject2Grade`}
              errors={errors?.educationSubject2Grade}
              touched={touched?.educationSubject2Grade}
            />
          </div>

          <div className="col-md-7">
            <ErrorMessage
              name={"educationSubject3"}
              label="Education Subject 3"
              type="text"
              key={`error_educationSubject3Grade`}
              errors={errors?.educationSubject3}
              touched={touched?.educationSubject3}
            />
          </div>
          <div className="col-md-5">
            <ErrorMessage
              name={"educationSubject3Grade"}
              label="Education Subject 3 Grade (A, B, C, D, ...)"
              type="text"
              key={`error_educationSubject3Grade`}
              errors={errors?.educationSubject3Grade}
              touched={touched?.educationSubject3Grade}
            />
          </div>
          <div className="col-md-12">
            <button disabled={isSubmitting} type="submit" className="btn btn-primary btn-block btn-lg">
              {isSubmitting ? "Please wait ..." : "Save changes"}
            </button>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default Ijmb;
